import { useState, useEffect } from 'react';

/**
 * Custom hook for payment countdown timer
 * @param {number} expiresAt - Timestamp when payment expires (milliseconds)
 * @returns {number} Time remaining in milliseconds
 */
export const usePaymentTimer = (expiresAt) => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    if (!expiresAt) return;

    // Set initial time remaining
    const remaining = expiresAt - Date.now();
    setTimeRemaining(Math.max(0, remaining));

    // Update every second
    const interval = setInterval(() => {
      const remaining = expiresAt - Date.now();
      setTimeRemaining(Math.max(0, remaining));
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return timeRemaining;
};

/**
 * Helper function to format milliseconds to MM:SS format
 * @param {number} ms - Milliseconds
 * @returns {string} Formatted time string (e.g., "5:30")
 */
export const formatTime = (ms) => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};